import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

const TwoRows = ({ children, className }) => (
  <div className={`TwoRows ${className}`}>
    {children}
  </div>
);

TwoRows.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
};

TwoRows.defaultProps = {
  children: [],
  className: '',
};

export default TwoRows;
